import React, { useState } from 'react';
import { DashboardContent } from '@/layouts/dashboard';
import { TiaBanner } from '@/components/custom/tia-banner';
import { Sheet, SheetBody, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { DialogTitle } from '@/components/ui/dialog';
import tiaInstrucoes from '@/assets/images/tia/TIA-INSTRUCOES.png';
import { ExercisesArchivePlayful } from './ExercisesArchivePlayful';
import { ExercisesCreateWizard } from '../ExercisesCreateWizard';

const TIA_MESSAGE = 'Escolha um caderno e comece a praticar. Bora dominar o assunto? 📝';

// O resultado dos exercícios agora vive em cada card (botão "Resultado"), então
// esta tela é só a lista de cadernos — sem a antiga aba "Resultados".
function ExercisesPlayful({ uri }) {
  const [showModal, setShowModal] = useState(false);

  const breadcrumbs = {
    title: 'Exercícios',
    nav: [{ route: uri, name: 'Exercícios', isActive: true }]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <TiaBanner
        className="mb-6 md:mt-16"
        image={tiaInstrucoes}
        text={TIA_MESSAGE}
      />

      <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-center">
        <Sheet
          open={showModal}
          onOpenChange={setShowModal}
        >
          <SheetTrigger asChild>
            <button
              type="button"
              className="group/btn relative w-full overflow-hidden rounded-full px-6 py-3 text-sm font-extrabold text-white transition-transform duration-100 active:scale-[0.97] md:ml-auto md:w-auto"
              style={{ background: 'var(--gradient-btn-continue)', boxShadow: '0 4px 0 var(--color-mission-dark), 0 6px 12px rgba(245,123,46,0.35)' }}
            >
              <span
                aria-hidden="true"
                className="pointer-events-none absolute inset-x-0 top-0 h-1/2 rounded-t-full"
                style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.22) 0%, transparent 100%)' }}
              />
              <span className="relative">Criar exercício</span>
            </button>
          </SheetTrigger>

          <SheetContent>
            <DialogTitle className="sr-only">Novo exercício</DialogTitle>
            <SheetBody className="py-6">
              <ExercisesCreateWizard setShowModal={setShowModal} />
            </SheetBody>
          </SheetContent>
        </Sheet>
      </div>

      <ExercisesArchivePlayful />
    </DashboardContent>
  );
}

export default ExercisesPlayful;
